import { type } from "arktype";
import type { Server } from "bun";

export const RoomId = type("string.url");
export type RoomId = typeof RoomId.infer;

export const Room = type({
  roomId: RoomId,
  subscribers: "number",
});
export type Room = typeof Room.infer;

export const RoomMeta = type({
  "title?": "string | undefined",
  "image?": "string.url | undefined",
});
export type RoomMeta = typeof RoomMeta.infer;

export const WSConnectData = type({
  roomId: RoomId,
});
export type WSConnectData = typeof WSConnectData.infer;

export const Message = type("string <= 140");
export type Message = typeof Message.infer;

export const ServerMessage = type({
  type: "'message'",
  timestamp: "string.date.parse",
  content: Message,
  subscribers: "number",
})
  .or({
    type: "'error'",
    message: "string",
  })
  .or({
    type: "'ad'",
    timestamp: "string.date.parse",
    content: "string",
    subscribers: "number",
  });
export type ServerMessage = typeof ServerMessage.infer;

export const Script = type("'bubble.js' | 'sidebar.js'");
export type Script = typeof Script.infer;

// Define DisplayMessage type locally if not imported
export interface DisplayMessage {
  type: ServerMessage["type"];
  id: string;
  content: string;
  timestamp: Date;
  isStatus?: boolean; // Optional flag for status messages
}
